import differenceInDays from 'date-fns/differenceInDays';

/**
 * Returns the days left until `targetDate` while rounding up fractional days
 * If the target date is in the past, this function will return 0.
 */
export function getDaysUntil(targetDate: Date): number {
	const now = Date.now();

	if (targetDate.valueOf() <= now) {
		return 0;
	}

	return differenceInDays(targetDate, now) + 1;
}
